export class VacationScoutCensusSummaryForm {
    public comment
    public startDate
    public endDate

    constructor({
        comment: comment,
        startDate: startDate,
        endDate: endDate,
    }: {
        comment?: string,
        startDate: string,
        endDate: string,
    }) {
        this.comment = comment
        this.startDate = startDate
        this.endDate = endDate
    }
}
